import { TABLA_DETALLE_ESPACIO_POR_CEREAL_LINEA_12 } from '../../../../../config/tables'
import { TablaDetalleEspacioPorCerealLinea12Service } from '../../../../../models/movimiento/distribucionEspacioPorCereal/Tabla_detalle_espacio_por_cereal_linea_12'
import { COLUMNS_DETALLE_ESPACIO_POR_CEREAL_LINEA_12, COLUMNS_DETALLE_ESPACIO_POR_CEREAL_LINEA_12_TO_PRINT } from './constantesDetalleEspacioPorCerealLinea12'
import { pdfCustomToolbarGenerator } from '../../../../../models/tools/generarPdf'

export function actualizarDatosParaMuiTable () {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_DETALLE_ESPACIO_POR_CEREAL_LINEA_12
    })
    const promiseTablaDetalleEspacioPorCerealLinea12 = TablaDetalleEspacioPorCerealLinea12Service.getDataTablaDetalleEspacioPorCerealLinea12()
    const promiseTablaDetalleEspacioPorCerealLinea12Total = TablaDetalleEspacioPorCerealLinea12Service.getDataTablaDetalleEspacioPorCerealLinea12Total()
    Promise.all([promiseTablaDetalleEspacioPorCerealLinea12, promiseTablaDetalleEspacioPorCerealLinea12Total]).then(callback)
    function callback (dataArray) {
      const dataCombinada = dataArray[0].filas || []
      const filaTotalArreglada = dataArray[1].filas[0]
      filaTotalArreglada['cereal'] = 'Total'
      dataCombinada.push(filaTotalArreglada)
      const customToolbar = pdfCustomToolbarGenerator(
        'Espacio Por Cereal Sector 1-2',
        dataCombinada,
        COLUMNS_DETALLE_ESPACIO_POR_CEREAL_LINEA_12_TO_PRINT,
        'portrait')
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_DETALLE_ESPACIO_POR_CEREAL_LINEA_12,
          data: dataCombinada,
          title: `Espacio Por Cereal Sector 1-2`,
          isLoading: false,
          fixed2Decimales: true,
          extraOptions: { customToolbar, pagination: false }
        },
        id: TABLA_DETALLE_ESPACIO_POR_CEREAL_LINEA_12
      })
    }
  }
}
